import { Component, HostListener, inject, output } from '@angular/core';

import {
  CancelButtonComponent,
  CloseIconButtonComponent,
  OutlinedSubmitButtonComponent,
} from '@sandbox-platform/shared-ui';

import { CommissionInvoiceFilterDisplayStore } from '../+state/commission-invoice-filter-display.store';
import { COMMISSION_INVOICE_PAYEE_TYPE } from '../../../../shared/definitons';
import { OrganizationSelectionInputComponent } from '../../../../shared/components';

@Component({
  standalone: true,
  imports: [
    CancelButtonComponent,
    CloseIconButtonComponent,
    OrganizationSelectionInputComponent,
    OutlinedSubmitButtonComponent,
  ],
  selector: 'lib-commission-invoice-filter-dialog',
  templateUrl: './commission-invoice-filter-dialog.component.html',
})
export class CommissionInvoiceFilterDialogComponent {
  protected readonly filterDisplayStore = inject(
    CommissionInvoiceFilterDisplayStore
  );

  protected readonly statusOptions = [
    { value: 'all', label: 'All statuses' },
    { value: 'draft', label: 'Draft' },
    { value: 'pending_approval', label: 'Pending Approval' },
    { value: 'approved', label: 'Approved' },
    { value: 'sent', label: 'Sent' },
    { value: 'partially_paid', label: 'Partially Paid' },
    { value: 'paid', label: 'Paid' },
    { value: 'cancelled', label: 'Cancelled' },
  ] as const;

  protected readonly PAYEE_TYPE = COMMISSION_INVOICE_PAYEE_TYPE;

  protected readonly payeeTypeOptions = [
    { value: 'all' as const, label: 'All payees' },
    {
      value: COMMISSION_INVOICE_PAYEE_TYPE.ExpertIndividual,
      label: 'Expert Individual',
    },
    {
      value: COMMISSION_INVOICE_PAYEE_TYPE.ExpertOrganization,
      label: 'Expert Organization',
    },
  ];

  dialogCancel = output<void>();
  apply = output<void>();

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    if (this.filterDisplayStore.isDialogOpen()) {
      this.onCancel();
    }
  }

  protected onApply(): void {
    this.apply.emit();
  }

  protected onCancel(): void {
    this.filterDisplayStore.closeDialog();
    this.dialogCancel.emit();
  }

  protected onClear(): void {
    this.filterDisplayStore.resetDraft();
  }
}
